import { Icon } from '@chakra-ui/react';
import React from 'react';

type Props = {
  isGrayscale?: boolean;
  h?: (string | number | null)[] | string | number;
  w?: (string | number | null)[] | string | number;
  color?: string;
};
const Logo = ({ isGrayscale, ...rest }: Props) => (
  <Icon viewBox="0 0 197.562 56" color="brand.500" {...rest}>
    <defs>
      <linearGradient
        id="a"
        y1="0.5"
        x2="1"
        y2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#cce0f4" />
        <stop offset="0.12" stopColor="#c2ddef" />
        <stop offset="0.32" stopColor="#a9d6e3" />
        <stop offset="0.567" stopColor="#81cbd1" />
        <stop offset="0.865" stopColor="#74c4cb" />
        <stop offset="0.994" stopColor="#46c2cd" />
      </linearGradient>
      <linearGradient id="b" x1="1" x2="0" xlinkHref="#a" />
    </defs>
    <g transform="translate(-65 -53.969)">
      <g transform="translate(65 54.877)">
        <path
          d="M2340.849,4009.69s7.595,6.378,15.851,13.939a17.473,17.473,0,0,1,4.589,6.919c.751,2.056.591,7.486.544,8.7v17.557a1.138,1.138,0,0,1-2.028.709l-20.737-26.12a1.135,1.135,0,0,1-.248-.709V4010.4a1.138,1.138,0,0,1,2.028-.71Z"
          transform="translate(-2334.681 -4009.262)"
          fill={isGrayscale ? `#B0B0B0` : `url(#a)`}
        />
        <path
          d="M2354.67,4065.568l-24.876-31.207a1.135,1.135,0,0,1-.248-.709v-20.285a1.138,1.138,0,0,1,2.028-.709l24.876,31.207a1.139,1.139,0,0,1,.248.709v20.286a1.138,1.138,0,0,1-2.028.708Z"
          transform="translate(-2329.546 -4010.905)"
          fill="currentColor"
        />
        <path
          d="M2420.7,4009.69s-7.6,6.378-15.851,13.939a17.469,17.469,0,0,0-4.589,6.919c-.751,2.056-.591,7.486-.545,8.7v17.557a1.138,1.138,0,0,0,2.028.709l20.737-26.12a1.138,1.138,0,0,0,.248-.709V4010.4a1.138,1.138,0,0,0-2.027-.71Z"
          transform="translate(-2368.372 -4009.262)"
          fill={isGrayscale ? `#B0B0B0` : `url(#b)`}
        />
        <path
          d="M2401.8,4065.567l24.876-31.206a1.14,1.14,0,0,0,.248-.71v-20.285a1.138,1.138,0,0,0-2.028-.709l-24.877,31.207a1.14,1.14,0,0,0-.247.709v20.286a1.138,1.138,0,0,0,2.028.709Z"
          transform="translate(-2368.429 -4010.904)"
          fill="currentColor"
        />
        <g transform="translate(65.306 8.072)">
          <g transform="translate(0 0)">
            <path
              d="M2496.6,4028.675v21.79c0,5.709-3.615,8.328-10.371,8.328s-10.372-2.619-10.372-8.328v-21.79c0-5.71,3.615-8.329,10.372-8.329S2496.6,4022.965,2496.6,4028.675Zm-12.989,0v21.79a2.624,2.624,0,0,0,5.238,0v-21.79a2.625,2.625,0,0,0-5.239,0Z"
              transform="translate(-2475.86 -4020.346)"
              fill="currentColor"
            />
            <path
              d="M2539.469,4052.99h7.594a1.957,1.957,0,0,1,2.147,2.147v1.572a1.958,1.958,0,0,1-2.147,2.147h-13.2a1.958,1.958,0,0,1-2.147-2.147V4023.08a1.957,1.957,0,0,1,2.147-2.148h3.458a1.958,1.958,0,0,1,2.147,2.148Z"
              transform="translate(-2506.785 -4020.67)"
              fill="currentColor"
            />
            <path
              d="M2576.989,4026.8v29.909a1.958,1.958,0,0,1-2.147,2.147h-3.458a1.958,1.958,0,0,1-2.148-2.147V4026.8h-4.977a1.958,1.958,0,0,1-2.147-2.147v-1.572a1.957,1.957,0,0,1,2.147-2.148h17.7a1.958,1.958,0,0,1,2.148,2.148v1.572a1.958,1.958,0,0,1-2.148,2.147Z"
              transform="translate(-2523.614 -4020.67)"
              fill="currentColor"
            />
            <path
              d="M2633.012,4043.091l4.767,12.677c.419,1.1.157,3.09-1.99,3.09h-3.615a2.027,2.027,0,0,1-2.095-1.415l-4.662-13.095h-1.572v12.363a1.958,1.958,0,0,1-2.148,2.147h-3.457a1.958,1.958,0,0,1-2.148-2.147v-33.628a1.958,1.958,0,0,1,2.148-2.148h8.223c6.757,0,10.372,2.619,10.372,8.329v6.757C2636.835,4039.477,2635.526,4041.781,2633.012,4043.091Zm-6.547-4.609a2.355,2.355,0,0,0,2.618-2.462v-6.757a2.356,2.356,0,0,0-2.618-2.462h-2.619v11.681Z"
              transform="translate(-2553.5 -4020.673)"
              fill="currentColor"
            />
            <path
              d="M2738.565,4023.081a1.958,1.958,0,0,1,2.148-2.148h2.933a1.958,1.958,0,0,1,2.148,2.148v33.628a1.958,1.958,0,0,1-2.148,2.147h-3.508a2.045,2.045,0,0,1-2.148-1.571l-3.928-11.314-2.566-9.114-.524.1.786,9.376v10.371a1.958,1.958,0,0,1-2.147,2.147h-2.934a1.957,1.957,0,0,1-2.147-2.147V4023.08a1.957,1.957,0,0,1,2.147-2.148h3.509a2.044,2.044,0,0,1,2.148,1.572l3.928,11.314,2.567,9.114.523-.105-.786-9.375Z"
              transform="translate(-2613.538 -4020.67)"
              fill="currentColor"
            />
          </g>
          <g transform="translate(85.957 0.263)">
            <path
              d="M2688.031,4075.557l0,.01.118-1.007Z"
              transform="translate(-2679.288 -4050.625)"
              fill="currentColor"
            />
            <path
              d="M2700.588,4089.938h0l.093.764Z"
              transform="translate(-2686.24 -4059.14)"
              fill="currentColor"
            />
            <path
              d="M2690.8,4056.187l-5.029-33.208c-.209-1.518-.995-2.043-2.2-2.043h-7.856c-1.2,0-1.99.523-2.2,2.043l-5.029,33.208c-.262,1.571.523,2.671,2.1,2.671h3.143a1.946,1.946,0,0,0,2.147-1.886l.536-4.473h0l.777-6.622,0-.01.123-1h0l.61-4.974,1.466-10.415h.524l1.467,10.415.5,4.342h0l.917,7.5h0l.092.764h0l.536,4.474a1.946,1.946,0,0,0,2.147,1.885h3.143C2690.28,4058.859,2691.066,4057.758,2690.8,4056.187Z"
              transform="translate(-2668.442 -4020.937)"
              fill="currentColor"
            />
            <path
              d="M2688.306,4074.558Z"
              transform="translate(-2679.44 -4050.625)"
              fill="currentColor"
            />
            <path
              d="M2700.793,4091.65Z"
              transform="translate(-2686.354 -4060.087)"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
      <path
        d="M2354.67,4065.568l-24.876-31.207a1.135,1.135,0,0,1-.248-.709v-20.285a1.138,1.138,0,0,1,2.028-.709l24.876,31.207a1.139,1.139,0,0,1,.248.709v20.286a1.138,1.138,0,0,1-2.028.708Z"
        transform="translate(-2264.546 -3958.259)"
        fill="currentColor"
      />
      <path
        d="M2401.8,4065.567l24.876-31.206a1.14,1.14,0,0,0,.248-.71v-20.285a1.138,1.138,0,0,0-2.028-.709l-24.877,31.207a1.14,1.14,0,0,0-.247.709v20.286a1.138,1.138,0,0,0,2.028.709Z"
        transform="translate(-2303.429 -3958.259)"
        fill="currentColor"
      />
    </g>
  </Icon>
);

export default Logo;
